<template>
  <div class="home">
    <transition name="slide-fade-left">
      <img
        v-if="showLogo"
        class="home__image"
        :src="require('../../public/icons/Blueberry_logo.svg')"
        alt="Logo"
      />
    </transition>

    <div class="core">
      <transition name="slide-fade-right">
        <h3 v-if="showTitle" class="text-h3 core__title">
          Top 10 Core Values:
        </h3>
      </transition>
      <div class="core__body">
        <transition name="slide-fade-left">
          <div v-if="show" class="core__body__values">
            <div class="core__body__values__item">
              1. Be the Change You Want to See in the World
            </div>
            <div class="core__body__values__item">2. Improve Lives</div>
            <div class="core__body__values__item">
              3. Be Independent Thinker
            </div>
            <div class="core__body__values__item">
              4. Seek Truth Very Few People Agree On
            </div>
            <div class="core__body__values__item">
              5. Act Rationally, Love Unconditionally
            </div>
          </div>
        </transition>

        <transition name="slide-fade-right">
          <div v-if="show" class="core__body__values">
            <div class="core__body__values__item">6. Obsess Over Customers</div>
            <div class="core__body__values__item">7. Invent and Simplify</div>
            <div class="core__body__values__item">8. Learn and Be Curious</div>
            <div class="core__body__values__item">
              9. Accomplish More With Less
            </div>
            <div class="core__body__values__item">10. Be Humble</div>
          </div>
        </transition>
      </div>
    </div>
    <transition name="slide-fade-right">
      <img
        v-if="showImg"
        class="dots dots_light"
        :src="require('../../public/icons/Dots_Light.svg')"
        alt="Dots"
      />
    </transition>
    <transition name="slide-fade-left">
      <img
        v-if="showImg"
        class="dots dots_dark"
        :src="require('../../public/icons/Dots.svg')"
        alt="Dots"
      />
    </transition>
  </div>
</template>


<script>
export default {
  name: "Home",
  data() {
    return {
      show: false,
      showImg: false,
      showLogo: false,
      showTitle: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.showImg = true;
    }, 600);
    setTimeout(() => {
      this.show = true;
      this.showLogo = true;
      this.showTitle = true;
    }, 400);
  },
};
</script>

<style lang="scss">
.slide-fade-left-enter-active {
  transition: all 0.3s linear;
}
.slide-fade-left-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-left-enter, .slide-fade-leave-to
/* .slide-fade-leave-active до версии 2.1.8 */ {
  transform: translateX(-100px);
  opacity: 0;
}
.slide-fade-right-enter-active {
  transition: all 0.3s linear;
}
.slide-fade-right-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-right-enter, .slide-fade-leave-to
/* .slide-fade-leave-active до версии 2.1.8 */ {
  transform: translateX(100px);
  opacity: 0;
}
.home {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: calc(100vh - 64px);
  &__image {
    width: 600px;
    height: auto;
    margin-bottom: 100px;
  }

  .core {
    &__title {
      text-align: center;
      margin-bottom: 20px;
    }
    &__body {
      display: flex;
      &__values {
        display: flex;
        flex-direction: column;

        &__item {
          border-radius: 4px;
          display: block;
          padding: 10px 20px;
          background-color: #fffbfb;
          // border: 1px solid #fffbfb;
          transition: all 0.3s linear;
          &:hover {
            background-color: #5fbff9;
            color: white;
            // border-color: #5fbff9;
            transform: translateX(-10px);
          }
        }
      }
    }
  }

  .dots {
    position: absolute;
    width: 200px;
    height: 200px;
    // animation: rotateDots 5s linear infinite;
    &_light {
      top: 50px;
      right: 50px;
    }
    &_dark {
      bottom: 50px;
      left: 50px;
    }
  }
}

@keyframes rotateDots {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>